import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import basicScienceFacultyData from "./facultyData/basicScienceFacultyData";

const departmentOverview = {
  paragraphs: [""],
};

const facultyOrder = [
  "f-meenal-m-kaliwal",
  "f-vijaya-chitrali",
  "f-akshata-b-patil",
  "f-satish-hande",
];

const getOrderedFacultyMembers = (members = []) => [
  ...facultyOrder
    .map((id) => members.find((faculty) => faculty.id === id))
    .filter(Boolean),
  ...members.filter((faculty) => !facultyOrder.includes(faculty.id)),
];

const mathsFacultyData = {
  hod: null,
  members: getOrderedFacultyMembers(
    basicScienceFacultyData.members.filter((faculty) =>
      facultyOrder.includes(faculty.id)
    )
  ),
};

export const programme = {
  id: "maths",
  name: "Mathematics",
  short: "Maths",
  programmeType: "ug",
  programmeLabel: "",
  duration: "First-year engineering foundation",
  intake: "510+",
  established: 2004,
  description:
    "The Department of Mathematics strengthens analytical thinking through applied mathematics, calculus, linear algebra, transforms, numerical methods, and engineering problem-solving.",
  departmentOverview,
  dashboard: [
    ["Faculty Members", "03"],
    ["Faculty with Ph.D.", "03"],
    ["Laboratories", "01"],
    ["Students Enrolled", "510+"],
  ],
  academicOverview: [
    {
      title: "Academic Strengths",
      text: "The department has experienced faculty, modern laboratories, and strong mentoring support.Students consistently perform well in VTU examinations and engage in research activities.Industry interaction, value education, and professional ethics support overall development",
    },
     {
      title: "Practical Learning and Innovation",
      text: "The department combines classroom learning with Engineering Physics laboratory practice, demonstrations, and applied experiments.",
    },
    {
      title: "Beyond Syllabus",
      text: "Students connect physics foundations with materials, electronics, optics, computational methods, and emerging engineering applications.",
    },
  ],
  image:
    "/Campus/maths.jpg",

  facultyDeptId: "bsh",
  facultyData: mathsFacultyData,
  labs: ["Mathematics Learning Centre"],
  research:
    "Graph Theory · Discrete Mathematics · Linear Algebra · Numerical Methods",
  accreditation: [
    "VTU-affiliated first-year curriculum",
    "AICTE-approved engineering programme support",
  ],
  achievements: [
    {
      title: "Achievement Documents",
      items: [
        { label: "Mathematics Achievements", href: "#" },
      ],
    },
  ],
  projects: [],
};

const Maths = () => <ProgrammeDetail programme={programme} />;

export default Maths;
